export default __webpack_public_path__ + "static/media/connexion.cda7d382.jpg";